export default __webpack_public_path__ + "static/media/video_bg.ff82402f.jpg";